import { render, staticRenderFns } from "./CustomerContextSelector.vue?vue&type=template&id=935e71ba&"
import script from "./CustomerContextSelector.vue?vue&type=script&lang=js&"
export * from "./CustomerContextSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports